<template>
  <el-dialog
    title="填写通过备注"
    :visible="dialogVisible"
    @close="handleClose"
    width="30%"
    top="15%"
  >
    <div v-if="showInvoiceDate" class="flex items_center mt20">
      <span>
        <span style="color: red">*</span>
        实际对冲日期：
      </span>
      <el-date-picker
        style="width: 140px"
        v-model="bizParam"
        type="date"
        :picker-options="{
          disabledDate: (time) => time.getTime() > Date.now(),
        }"
        placeholder="请选择"
      >
      </el-date-picker>
    </div>
    <el-input
      class="mt20"
      type="textarea"
      :rows="5"
      placeholder="请填写通过备注（选填）"
      v-model="approveSuggest"
      maxlength="100"
    >
    </el-input>
    <span slot="footer" class="dialog-footer">
      <el-button type="info" class="w100f" @click="handleSubmit()"
        >通过</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "PassDialog",
  props: {
    showInvoiceDate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: false,
      approveSuggest: "",
      bizParam: null,
    };
  },
  methods: {
    open() {
      this.dialogVisible = true;
      this.approveSuggest = "";
      this.bizParam = null;
    },
    close() {
      this.dialogVisible = false;
    },
    handleSubmit() {
      if (this.showInvoiceDate) {
        if (!this.bizParam) {
          return this.$message.error("请选择实际对冲日期");
        }
      }
      this.$emit("submit", {
        approveSuggest: this.approveSuggest,
        bizParam: this.$moment(this.bizParam).format('YYYY-MM-DD'),
      });
    },
    handleClose() {
      this.close();
    },
  },
};
</script>

<style scoped>
:deep(.el-dialog__body) {
  padding: 0px 20px;
}
</style>
